import { Route, Redirect } from "react-router-dom";
import userContext from "../contexts/userContext";
import React, { useContext } from "react";
import Creation from "../example-pages/Creation";

const PrivateRoutes = () => {
  const { role, setRole } = useContext(userContext);
  return role.user &&
    role.user.roles &&
    [
      "Chargeur Principal",
      "Sous Compte Chargeur",
      "Chargeur Secondaire",
    ].includes(role.user.roles[0].name) ? (
    <Route path="/Creation/:mode?/:sens?" component={Creation} />
  ) : (
    <Redirect to="/PagesError505" />
  );
};

export default PrivateRoutes;
